import classApi from '@/api/class'

const state = {
    classifications: [],
};

const actions = {
    loadClassifications({ commit }) {
        classApi.queryClassification((classifications) => {
            classifications.sort((a, b) => {
                return a.sequenceNum - b.sequenceNum || a.TypeID - b.TypeID;
            });
            commit('setClassifications', { classifications });
        });
    },
};

const mutations = {
    setClassifications(state, { classifications }) {
        state.classifications = classifications;
    }
};

const getters = {
    classifications(state) {
        return state.classifications;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
